export default __webpack_public_path__ + "static/media/image.eshops-lk.d44a5829.png";